import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import errorMap from '../resources/error_map.json';

const getErrorMessage = (error) => {
    if (error) {
        // const code = error?.response?.data?.error_code || error.message;
        let msg = "";
        const code = error?.response?.data?.error_code
        if (code) {
            msg = `Error "${code}" has just happened. Please, reload the app or try again later.`;
        } else {
            msg = error.message;
        }
        let duration = null; // Default to null, to use the default autoHideDuration unless specified
        if (code in errorMap) {
			const errObj = errorMap[code];
        	msg = errObj.message; // Assuming errorMap now has an object with message and possibly autoHideDuration
			if ("autoHideDuration" in errObj) {
				duration = errObj.autoHideDuration 
				duration = parseInt(duration)
			}
        }
        const details = error?.response?.data?.details;
		
        if (details && ('reason' in details)) {
            // msg += ` for the following reason: ${details.reason}`;
			console.log('getErrorMessage: ',details)
        }
        return { msg, code, duration };
    }
    return { msg: null, code: null, duration: null };
}

function ErrorCatcher({
    error,
    position = { vertical: 'top', horizontal: 'center' },
    severity = "error",
    resetError = null,
    callBackMapOpen = {},
    callBackMapClose = {},
    autoHideDuration = 10000,
    clickAwayExit = true,
    navigateToLogin = false,
}) {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorCode, setErrorCode] = useState(null);
    const [errorAutoHideDuration, setErrorAutoHideDuration] = useState(autoHideDuration);
    const navigate = useNavigate();

    const handleMessage = (error) => {
        const { msg, code, duration } = getErrorMessage(error);
        setErrorCode(code);
        setErrorMessage(msg);
        setErrorAutoHideDuration(duration || autoHideDuration); // Use specific duration or default
        if (callBackMapOpen) {
            if (callBackMapOpen.hasOwnProperty(code)) {
                callBackMapOpen[code]();
            }
        }
        if (navigateToLogin && code === '401') {
            navigate('/login');
        }
        switch (severity) {
            case "error":
                console.error(msg);
                break;
            case "info":
                console.info(msg)
                break;
            case "warning":
                console.warn(msg);
                break;
            default:
                console.log(msg)
        }
    }

    useEffect(() => {
        if (error) {
            handleMessage(error);
            setOpen(true);
        }
    // eslint-disable-next-line
    }, [error, callBackMapOpen, callBackMapClose, severity])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            if (! clickAwayExit) {
                return;
            }
        }

        if (callBackMapClose && (errorCode in callBackMapClose)) {
            callBackMapClose[errorCode]();
        }
        if (resetError) {
            resetError();
        }
        if (navigateToLogin) {
            navigate('/login');
        }
        setOpen(false);
    };

    if (error === null) {
        return (null);
    }

    return (
        <Box>
            {errorMessage &&
                <Snackbar open={open} autoHideDuration={errorAutoHideDuration} onClose={handleClose}
                    anchorOrigin={{
                        vertical: position.vertical,
                        horizontal: position.horizontal,
                    }}
                >
                    <Alert onClose={handleClose}
                        severity={severity}
                        sx={{
                            minWidth: '200px',
                            minHeight: '40px',
                            maxWidth: 800,
                            fontSize: '1.15rem', // Increases the font size
                            padding: '15px', // Increases the padding inside the alert
                            borderRadius: '18px',
                        }}
                    >{errorMessage}
                    </Alert>
                </Snackbar>
            }
        </Box>
    );
}

export { getErrorMessage, ErrorCatcher };
